var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "message"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29291",
    "data-name": "Rectangle 29291",
    width: 16,
    height: 16,
    transform: "translate(288 352)",
    fill: "#7e59d1",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_688",
    "data-name": "Mask Group 688",
    transform: "translate(-288 -352)",
    clipPath: "url(#message)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-05-09T105527.997",
    "data-name": "svgexport-6 - 2022-05-09T105527.997",
    transform: "translate(288 352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11628",
    "data-name": "Group 11628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11627",
    "data-name": "Group 11627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11658",
    "data-name": "Path 11658",
    d: "M10.367,8.664l-1.34,1.345a1.483,1.483,0,0,1-2.055,0L5.633,8.664.82,13.493a1.392,1.392,0,0,0,.587.132H14.594a1.391,1.391,0,0,0,.587-.132Z",
    fill: "#7e59d1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11630",
    "data-name": "Group 11630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11629",
    "data-name": "Group 11629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11659",
    "data-name": "Path 11659",
    d: "M14.594,2.375H1.406a1.392,1.392,0,0,0-.587.132l5.143,5.16h0L7.636,9.347a.563.563,0,0,0,.727,0l1.672-1.678h0l5.143-5.16A1.391,1.391,0,0,0,14.594,2.375Z",
    fill: "#7e59d1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11632",
    "data-name": "Group 11632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11631",
    "data-name": "Group 11631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11660",
    "data-name": "Path 11660",
    d: "M.15,3.163A1.389,1.389,0,0,0,0,3.781v8.438a1.389,1.389,0,0,0,.15.618L4.971,8Z",
    fill: "#7e59d1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11634",
    "data-name": "Group 11634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11633",
    "data-name": "Group 11633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11661",
    "data-name": "Path 11661",
    d: "M15.85,3.163,11.029,8l4.821,4.837a1.389,1.389,0,0,0,.15-.618V3.781A1.389,1.389,0,0,0,15.85,3.163Z",
    fill: "#7e59d1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.b4905e622dfd4e7b1e847013bd73778c.svg";
export { ForwardRef as ReactComponent };